import { FileTextIcon, ZapIcon, FootprintsIcon, GaugeIcon, TrophyIcon, ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
export const heroChips = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: FootprintsIcon,
  label: 'Principiantes'
}, {
  icon: GaugeIcon,
  label: 'Intermedios'
}, {
  icon: TrophyIcon,
  label: 'Avanzados'
}];
export const heroTrust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Crédito / Débito'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export const stats = [{
  value: '+500',
  label: "Personas confiaron"
}, {
  value: '12',
  label: 'Tomos listos'
}, {
  value: '5',
  label: 'Bonos incluidos'
}, {
  value: '4.6/5',
  label: 'Calificación'
}];